<template>
	<div class="flow-sidebar-item">
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "SidebarItem"
});
</script>
<style lang="scss">
div.flow-sidebar-item {
	// margin-top: 12px;

	> div.slab-hierarchy > div.slab-container {
		padding-right: 0px;
		// border-bottom: 1px solid var(--dashboard-border);
		> div.slab-content > div.slab-title > span.slab-title-wrapper {
			display: inline-flex;
			align-items: center;
			overflow: visible;

			> * {
				margin-right: 12px;
				overflow: visible;
			}
		}
	}

	div.slab-hierarchy
		> div.slab-container[state="default"][state="default"][selected][type="bottom-border"] {
		background: none !important;
	}

	div.slab-hierarchy > div.slab-container[state="default"][selected]:not([disabled]):after {
		border-left: 3px solid var(--dashboard-primary);
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
	}

	div.slab-hierarchy
		> div.slab-container
		> div.slab-content
		> div.slab-title
		> span.slab-title-wrapper
		*
		+ p {
		margin-top: 0px;
	}
}

// div.flow-sidebar-item ~ div.flow-sidebar-item {
// 	margin-top: 0px;
// }
</style>
